import { Injectable } from '@angular/core';
import {
  DataViewsControllerService,
  SystemLinkControllerService,
} from '@osos/shared/api';
import { ManagedHttpContext } from '@osos/shared/types';
import { Observable } from 'rxjs';

@Injectable()
export class ViewDataService extends DataViewsControllerService {
  static readonly DataViewsControllerFindByIdForEndUserPath =
    '/v1/views/end-user/{view}';

  constructor(private sysService: SystemLinkControllerService) {
    super();
  }

  generateViewUrlToken(): Observable<any> {
    return this.sysService.generateToken();
  }

  findAnonymousViewByToken(token: string) {
    return this.sysService.getAnonymousView({
      token,
      context: new ManagedHttpContext({ bypassPublicMiddleware: true }),
    });
  }

  canUserAccessDataView(viewId: string): Observable<boolean> {
    return this.canUserAccessView({
      id: viewId,
    });
  }
}
